import React, { useEffect, useReducer, useState } from "react";
import "./../styles/Courses.css";
import LevelComponent from "./layout/Level";
import premiumLogo from "./../assets/premium.png";
import LoadingData from "../Common/LoadingData";

// action
export const SetData = "setData";
export const FilterLevel = "filterLevel";
export const FilterMembership = "filterMembership";
export const All = "all";
export const Level = "level";
// reducer
export const reducer = (state, action) => {
  switch (action.type) {
    case SetData:
      return {
        ...state,
        data: action.payload,
        courses: action.payload,
      };

    case FilterMembership:
      const filterMembership = state.data
        .map((item) => {
          return Array(item).map((arr) => {
            return {
              ...arr,
              courses: arr.courses.filter(
                (ele) => ele.membership === action.payload
              ),
            };
          });
        })
        .flat()
        .filter((item) => item.courses.length);

      let filterMembershipLevel = filterMembership.filter(
        (item) => item._id === state.levelType
      );

      const filterLevelM = state.data.filter(
        (item) => item._id === state.levelType
      );

      return {
        ...state,
        reads:
          action.payload === All && state.levelType === Level
            ? state.data
            : state.levelType !== Level && action.payload === All
            ? filterLevelM
            : state.levelType !== Level
            ? filterMembershipLevel
            : filterMembership,
        membershipType: action.payload,
      };

    case FilterLevel:
      const filterLevel = state.data.filter(
        (item) => item._id === action.payload
      );

      let filterLevelMembership = filterLevel.map((item) => {
        return {
          ...item,
          courses: item.courses.filter(
            (ele) => ele.membership === state.membershipType
          ),
        };
      });

      return {
        ...state,
        courses:
          action.payload === Level
            ? state.data
            : state.membershipType !== All
            ? filterLevelMembership
            : filterLevel,
        levelType: action.payload,
      };

    default:
      return state;
  }
};

const Courses = () => {
  const [loading, setLoading] = useState(true);
  const [state, dispatch] = useReducer(reducer, {
    levelType: Level,
    membershipType: All,
    courses: [],
    data: [],
  });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/courses`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        const level = {
          A1: [],
          A2: [],
          B1: [],
          B2: [],
          C1: [],
          C2: [],
        };
        data.msg.map((item) => {
          return Object.keys(level).forEach((key) => {
            if (key === item._id) {
              level[key].push(item);
            }
          });
        });
        const sort = Object.values(level).flat();
        dispatch({ type: SetData, payload: sort });
      });
  }, [dispatch]);

  // handel click Filter Membership
  const handelFilterMembership = (type, e) => {
    const membershipItem = document.querySelectorAll(".membership-item");

    membershipItem.forEach((item) => {
      item.children[0]?.classList.remove("membership-active");
      item.children[1]?.classList.remove("membership-active");
      item.classList.remove("membership-active");
    });
    e.target.classList.add("membership-active");

    dispatch({ type: FilterMembership, payload: type });
  };

  // handel click Filter level
  const handelFilterLevel = (type) => {
    dispatch({ type: FilterLevel, payload: type });
  };

  return loading ? (
    <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
      <div className="lds-dual-ring"></div>
    </div>
  ) : (
    <div className="courses">
      <div className="container">
        <div className="courses-about">
          <h1 className="header-title">Our Popular Courses</h1>
          <div className="category-container">
            <div className="membership d-flex justify-content-between align-items-center">
              <div
                className="membership-all membership-item membership-active"
                onClick={(e) => handelFilterMembership(All, e)}
                role={"button"}
                aria-label={"all"}
                data-membership={"all"}
              >
                <h6>All</h6>
              </div>
              <div
                className="membership-free membership-item"
                onClick={(e) => handelFilterMembership("freePlan", e)}
                role={"button"}
                aria-label={"free"}
                data-membership={"free"}
              >
                <h6>Free</h6>
              </div>
              <div
                className="membership-premium membership-item d-flex align-items-center"
                onClick={(e) => handelFilterMembership("premiumPlan", e)}
                role={"button"}
                aria-label={"premium"}
                data-membership={"premium"}
              >
                <img
                  style={{ width: "30px" }}
                  src={premiumLogo}
                  alt="premiumLogo"
                />
                <h6> Premium</h6>
              </div>
            </div>
            <div className="level-category">
              <select
                className="form-select"
                onChange={(e) => handelFilterLevel(e.target.value)}
              >
                <option value="level">Level</option>
                {state.data.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item._id}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <>
          {!state.courses.length > 0 ? (
            <LoadingData />
          ) : (
            <>
              {state.courses.map((item, index) => (
                <LevelComponent item={item} key={index} />
              ))}
            </>
          )}
        </>
      </div>
    </div>
  );
};

export default Courses;
